import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "Why You're Losing Sales (And How WhatsApp Can Fix It)",
    listHeading: "Are you struggling with missed leads, delayed responses, or low conversion rates? You're not alone, and the fix might be simpler than you think.",
    listText: [
        { label: "The top reasons businesses lose sales in today's digital age" },
        { label: "How WhatsApp can help solve each of these problems" },
        { label: "Real-life success stories from brands using WhatsApp to drive conversions" },
        { label: "Actionable strategies to implement immediately — no tech team required" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-1.png",
    speakerList: [
        {
            image: "/ranganayaki.png",
            name: "Ranganayaki R",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/LLlmpn8FeJc",
    inThisWebinar: "In this webinar, you'll discover:",
    webinarSlug: "losing-sales-whatsapp",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="Fix sales leaks with WhatsApp - Gallabox webinars"
            description="Discover how WhatsApp automation can stop lost sales and boost revenue fast. Access the webinar for FREE"
            canonical="https://gallabox.com/webinars/losing-sales-whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-1.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
